import React, { useState } from "react";
import Header from "./../header";
import Navvbar from "./../Navvbar";

const Support = () => {
  const [comments, setComments] = useState("");

  return (
    <>
      <div style={{ marginBottom: "10px" }}>
        <Header />
        <Navvbar />
      </div>
      <div
        style={{
          backgroundColor: "#EFEFEF",
          color: "black",
          padding: "20px",
          borderRadius: "16px",
          width: "95%",
          margin: "0 auto",
        }}
      >
        <div className="row">
          <div className="col-md-12">
            <h1 style={{ backgroundColor: "#EFEFEF", color: "black" }}>
              Hira Labnext Support
            </h1>
            <p>Have questions about using Labnext?</p>
            <p>Ran into a problem?</p>
            <p>
              Please describe your issue in the below form and a Labnext support
              technician will get in touch.
            </p>
            <p>Our support team can also be reached at 0-000-000-0000</p>
            <h2 style={{ color: "#4169E1" }}>Contact Us</h2>
            <form>
              <textarea
                value={comments}
                onChange={(e) => setComments(e.target.value)}
                style={{
                  width: "100%",
                  height: "200px",
                  outline: "none",
                  border: "none",
                  borderRadius: "4px",
                }}
                required
              />
              <button
                type="submit"
                style={{
                  backgroundColor: "#004aad",
                  color: "white",
                  marginTop: "8px",
                  border: "none",
                  padding: "10px 25px",
                  borderRadius: "4px",
                }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Support;
